// Enable RFQ button when GRFQConfigs.products is ready (length > 0)
(function () {
  var POLL_INTERVAL_MS = 50;
  var TIMEOUT_MS = 5000;
  var startedAt = Date.now();
  var intervalId = null;

  function getRfqButton() {
    return document.getElementById('rfq-cart-btn');
  }

  function hasProducts() {
    try {
      return (
        typeof window !== 'undefined' &&
        window.GRFQConfigs &&
        Array.isArray(window.GRFQConfigs.products) &&
        window.GRFQConfigs.products.length > 0
      );
    } catch (e) {
      return false;
    }
  }

  function enableButton(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.removeAttribute('disabled');
  }

  function maybeEnable() {
    var btn = getRfqButton();
    if (!btn) return; // wait until button exists in DOM
    if (hasProducts()) {
      enableButton(btn);
      stop();
    }
  }

  function stop() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  function start() {
    // Initial check once DOM is ready
    maybeEnable();
    // Polling until timeout or success
    intervalId = setInterval(function () {
      if (Date.now() - startedAt > TIMEOUT_MS) {
        stop();
        return;
      }
      maybeEnable();
    }, POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
